import { FETCH_SITE } from "../actions/siteActions";

const initState = {};

const siteReducer = (state = initState, action) => {
    if (action.type === FETCH_SITE) {
        // Replace, not merge — the locales of the previously visited site must not leak
        // into the current one.
        return {
            ...action.payload,
        };
    }

    return state;
};

export default siteReducer;
